// extracted by mini-css-extract-plugin
module.exports = {"__fade-transition-mixin":"button___fade-transition-mixin__16G86","button":"button_button__FTgid","ant-btn-background-ghost":"button_ant-btn-background-ghost__3TDne"};